import { render } from "./QuoteFacebook.vue?vue&type=template&id=2c812552&ts=true"
import script from "./QuoteFacebook.vue?vue&type=script&lang=ts"
export * from "./QuoteFacebook.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__